import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Order from '../entities/order';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Vuex from 'vuex';
Vue.use(Vuex);

interface OrderState extends ListState<Order> {
    editOrder: Order;
    orderno: string;
    total: '';
    shopid: '';
    paynum: number;
}

class OrderModule extends ListModule<OrderState, any, Order> {
    enshopid = Util.siss.auth.getenshopid();
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Order>(),
        loading: false,
        editTemplate: new Order(),
        paynum: 0,
        chargeeRouter: localStorage[this.enshopid + '_chargeeRouter'] ? JSON.parse(localStorage[this.enshopid + '_chargeeRouter']) : {},
    };
    public actions = {
        async getPagedOrders(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetPagedOrders', { params: payload.data });
            return reponse.data.result;
        },
        async addOrder(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/AddOrder', payload.data);
            const result = reponse.data.result;
            context.state.orderno = result.orderno;
            context.state.total = result.total;
            context.state.shopid = result.shopid;
            return result;
        },
        async getCancelOrder(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetCancelOrderInfo?orderno='
                + payload.data.orderno);
            return reponse.data.result;
        },
        async postCancel(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/PostCancel', payload.data);
            return reponse.data.result;
        },
        async getConfirmOrderDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/GetConfirmOrderDetail', payload.data);
            return reponse.data.result;
        },
        async getOrderDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetOrderDetail?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        async voucherforuselist(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/VoucherForUseList', payload.data);
            return reponse.data.result;
        },
        async checkStockFromOffline(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/CheckStockFromOffline', payload.data);
            return reponse.data.result;
        },
        async checkOfflineJifen(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/CheckHelper/CheckOfflineJifen');
            return reponse.data.result;
        },
        async getordertrack(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetOrderTrack?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        async getCandaoTrack(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Candao/GetCandaoTrack?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        async getUserUnCommentList(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserUnCommentList', payload.data);
            return reponse.data.result;
        },
        async getUserCommentList(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserCommentList', payload.data);
            return reponse.data.result;
        },
        async getUserCommentItemDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserCommentItemDetail?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        async getUserUnCommentItemDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserUnCommentItemDetail?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        async editComment(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/OrderComment/EditComment', payload.data);
            return reponse.data.result;
        },
        async getHistoryUnCommentList(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetHistoryUnCommentList', payload.data);
            return reponse.data.result;
        },
        async getHistoryCommentList(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetHistoryCommentList', payload.data);
            return reponse.data.result;
        },
        async getUserCommentDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserCommentDetail', { params: payload.data });
            return reponse.data.result;
        },
        async getUserUnCommentDetail(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetUserUnCommentDetail', { params: payload.data });
            return reponse.data.result;
        },
        async editOldComment(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/OrderComment/EditOldComment', payload.data);
            return reponse.data.result;
        },
        async getOrderInfoFromCache(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetOrderInfoFromCache');
            return reponse.data.result;
        },
        async GetOrderMasterInfo(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetOrderMasterInfo?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        
        async deleteOrder(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.delete('/api/services/app/MobileOrder/DeleteOrder?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },
        //获取快递信息
        async GetExpress(context: ActionContext<OrderState, any>, payload: any) {

            const reponse = await Ajax.post('/api/services/app/ExpressCompany/GetExpressinfoByOrderNo',payload.data.ordernos);
            return reponse.data.result;
        },
        async getOrderCancelValue(context: ActionContext<OrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileOrder/GetOrderCancelValue');
            return reponse.data.result;
        }
    };
    public mutations = {
        setCurrentPage(state: OrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: OrderState, Order: Order) {
            state.editOrder = Order;
        },
        updatePaynum(state: OrderState, num: number) {
            state.paynum = num;
        },
        updateOrderno(state: OrderState, orderno: string) {
            state.orderno = orderno;
        },
        setChargeeRouter(state, data) {
            state.chargeeRouter = data;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_chargeeRouter", JSON.stringify(data));
        },
    };
}
const orderModule = new OrderModule();
export default orderModule;
